/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetMetricEventInstancesPathParams = NonNullable<
  operations['getMetricEventInstances']['parameters']['path']
>;

export type GetMetricEventInstancesQueryParams = NonNullable<
  operations['getMetricEventInstances']['parameters']['query']
>;

export interface Input extends GetMetricEventInstancesPathParams {
  apiVersion?: string;
  query: GetMetricEventInstancesQueryParams;
}

export async function getMetricEventInstances(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projectKey}/metrics/{metricKey}/event-instances', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
